import { render, staticRenderFns } from "./catequest_note_list.vue?vue&type=template&id=1332b175&scoped=true"
import script from "./catequest_note_list.vue?vue&type=script&lang=js"
export * from "./catequest_note_list.vue?vue&type=script&lang=js"
import style0 from "./catequest_note_list.vue?vue&type=style&index=0&id=1332b175&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332b175",
  null
  
)

export default component.exports